<div class="addnewcategorydialog">
    <div mat-dialog-title class="d-flex align-items-center justify-content-between p-2">
        <span class="fw-600">{{ isAddNewQuestion ? 'Add New Category' : 'Select Category to delete' }}</span>
        <span><i class="fa fa-times model_close cursor-pointer" (click)="closeDialog()"></i></span>
    </div>
    <div mat-dialog-content class="p-2">
        <input *ngIf="isAddNewQuestion" type="text" placeholder="Enter Category Name" class="w-100 form-control" [(ngModel)]="categoryName" required>
        <mat-select *ngIf="!isAddNewQuestion" placeholder="Select Category" [(ngModel)]="selectedCategory" class="w-100 form-control">
            <mat-option *ngFor="let category of categories" [value]="category.id">{{ category.description }}</mat-option>
        </mat-select>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end px-3 pt-3">
        <button *ngIf="isAddNewQuestion" type="button" class="btn btn-primary mr-2" (click)="addCategoryButtonClicked()">Add</button>
        <button *ngIf="!isAddNewQuestion" type="button" class="btn btn-primary mr-2" (click)="deleteCategoryButtonClicked()">Delete</button>
        <button mat-raised-button color="warn" type="button" class="btn btn-secondary" (click)="closeDialog()">Cancel</button>
    </div>
</div>